import { render, staticRenderFns } from "./Confetti.vue?vue&type=template&id=abf71824&lang=pug"
import script from "./Confetti.vue?vue&type=script&lang=ts"
export * from "./Confetti.vue?vue&type=script&lang=ts"
import style0 from "./Confetti.vue?vue&type=style&index=0&id=abf71824&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports